/**
 * Modifiers Namespace
 * Organized collection of text modifiers by language
 */

// English modifiers namespace
export * as English from './english/index.js';

// Re-export individual English modifiers for convenience
export {
  ArticleModifier,
  PluralizationModifier,
  OrdinalModifier,
  CapitalizationModifier,
  PossessiveModifier,
  VerbAgreementModifier,
  PunctuationCleanupModifier,
  AllEnglishModifiers
} from './english/index.js';